import styles from './brandCarousel.module.scss'
import LogoCarousel from '../common/LogoCarousel'
import { BRAND_LOGOS } from '../../constants/images'

const brands = [
  { name: 'ButcherBox', img: BRAND_LOGOS.butcherBox },
  { name: 'Crocs', img: BRAND_LOGOS.crocs },
  { name: 'HeyDude', img: BRAND_LOGOS.heyDude },
  { name: 'RossSimons', img: BRAND_LOGOS.rossSimons },
  { name: 'Kipling', img: BRAND_LOGOS.kipling },
  { name: 'KitchenAid', img: BRAND_LOGOS.kitchenAid },
  { name: 'Kyte', img: BRAND_LOGOS.kyte },
  { name: 'SongMicHome', img: BRAND_LOGOS.songMicHome },
  { name: 'Lamps Plus', img: BRAND_LOGOS.lampsPlus },
  { name: 'DH', img: BRAND_LOGOS.dh },
  { name: 'Ray-Ban', img: BRAND_LOGOS.rayban },
  { name: 'DreamOnMe', img: BRAND_LOGOS.dreamOnMe },
  { name: 'Reebok', img: BRAND_LOGOS.reebok },
  { name: 'Timberland', img: BRAND_LOGOS.timberland },
  { name: 'Vera Bradley', img: BRAND_LOGOS.veraBradley },
]

const BrandCarousel = () => {
  return (
    <div className={styles.brandCarousel}>
      <LogoCarousel
        logos={brands}
        tagline="Home to brands guests know and love"
      />
    </div>
  )
}
export default BrandCarousel
